import proxy from '../../../proxy.json';

export const baseUrl = `${proxy['/federation-gateway/graphql']}/federation-gateway/graphql`;

export const headers = {
  headers: {
    'x-experience-name': 'custom-module-layout-designer'
  }
};

export const collectionHeaders = {
  'x-experience-name': 'custom-module-layout-designer'
};